export default "__VITE_ASSET__CfmHMNZ9__"